import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CourseGroupSlot, WildcardSlot } from '../../../../global/builders/ap_generic_slot_builder';
import { APTerm } from '../../../../global/builders/ap_term_builder';
import { INVALID_ID } from '../../../../global/constants/ap_id_constants';
import { IAPProgramSlotDatasource } from '../../../../global/datasources/ap_program_slot_datasource';
import { APGenericSlotServant } from '../../../../global/servants/ap_generic_slot_servant';
import { APDegreeMapQueryHelper } from '../../../../plan/queries/ap_degree_map_query_helper';
import { APTermCourseDataQueryhelper } from '../../../../plan/queries/ap_term_course_data_query_helper';
import { ILargeCourseGroupSearchResults } from '../../degree_map/queries/ap_degree_map_query';
import { LargeCourseGroupModel } from '../models/large_course_group_model';
import { LargeCourseGroupSearchResultModel } from '../models/large_course_group_search_result_model';

export interface ILargeCourseGroupSearchResult {
  largeCourseGroupSearchResults: ILargeCourseGroupSearchResults;
  highlightedTerm: APTerm['id'];
  totalCourses: number;
  title: string;
  showPagination: boolean;
  nextEnabled: boolean;
  prevEnabled: boolean;
  instructions?: string;
  showLargeCourseGroupBackdrop: boolean;
}

export class LargeCourseGroupSearchResultsQuery implements IQuery {
  private __result: ILargeCourseGroupSearchResult;

  constructor(
    private ngLargeCourseGroupModel: LargeCourseGroupModel,
    private ngLargeCourseGroupSearchResultModel: LargeCourseGroupSearchResultModel,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngAPTermCourseDataQueryhelper: APTermCourseDataQueryhelper,
    private ngAPDegreeMapQueryHelper: APDegreeMapQueryHelper,
    QueryMediator: IQueryMediator
  ) {
    QueryMediator.registerQuery(
      this,
      ngLargeCourseGroupModel,
      ngLargeCourseGroupSearchResultModel,
      ngAPProgramSlotDatasource
    );
  }

  run(): this {
    const largeCourseGroupModel = this.ngLargeCourseGroupModel.read();
    const nonDevReqGenericSlots = this.ngAPDegreeMapQueryHelper.buildNonDevGenericSlots();
    this.__result = {
      highlightedTerm: INVALID_ID,
      showLargeCourseGroupBackdrop: false,
      totalCourses: 0,
      title: '',
      showPagination: false,
      largeCourseGroupSearchResults: {
        genericSlots: []
      },
      nextEnabled: false,
      prevEnabled: false
    };
    if (_4.isEmpty(largeCourseGroupModel.selectedSlot)) {
      return this;
    }

    const nonDevReqGenericSlot = _4.first(
      nonDevReqGenericSlots.filter(
        (genericSlot): genericSlot is CourseGroupSlot | WildcardSlot =>
          genericSlot.programSlot.id === largeCourseGroupModel.selectedSlot.programSlot.id
      )
    );
    if (!nonDevReqGenericSlot) {
      return this;
    }

    const groupGenericSlots = this.ngAPDegreeMapQueryHelper.constructGroupGenericSlots(
      nonDevReqGenericSlot.programSlot
    );
    const largeCourseGroupDetails = this.ngAPTermCourseDataQueryhelper.getLargeCourseGroupSearchResult(
      nonDevReqGenericSlot,
      groupGenericSlots
    );
    const largeCourseGroupSearchResults = largeCourseGroupDetails.largeCourseGroupSearchResults;
    const largeCourseGroupSearchResultModel = this.ngLargeCourseGroupSearchResultModel.read();

    this.__result = {
      highlightedTerm: largeCourseGroupModel.selectedTerm,
      largeCourseGroupSearchResults,
      showLargeCourseGroupBackdrop: largeCourseGroupModel.selectedTerm !== INVALID_ID,
      totalCourses: largeCourseGroupSearchResultModel.count,
      nextEnabled: !_4.isNull(largeCourseGroupSearchResultModel.next),
      prevEnabled: !_4.isNull(largeCourseGroupSearchResultModel.previous),
      showPagination:
        !_4.isNull(largeCourseGroupSearchResultModel.next) || !_4.isNull(largeCourseGroupSearchResultModel.previous),
      title: largeCourseGroupModel.selectedSlot.title
    };

    if (APGenericSlotServant.isWildcardSlot(nonDevReqGenericSlot)) {
      this.__result.instructions = nonDevReqGenericSlot.instructions;
    }

    return this;
  }

  get result(): ILargeCourseGroupSearchResult {
    return this.__result;
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngLargeCourseGroupSearchResultsQuery', LargeCourseGroupSearchResultsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/queries/large_course_group_search_results_query.ts